import {GetOdontoAvailableTimesParams} from 'domain/usecases';
import {makeGetOdontoAvailableTimes} from 'main/factories/usecases';
import {sortAvailableTimes, sortByKey} from 'presentation/utils';

export async function getOdontoAvailableTimes(params: GetOdontoAvailableTimesParams) {
	const response = await makeGetOdontoAvailableTimes().get(params);

	if (!response) return [];

	const {horariosDisponiveis} = response;
	const parsedResponse = horariosDisponiveis.map(item => ({
		professionalName: item.nmPrestadorFisico,
		professionalCode: String(item.cdPrestadorFisico),
		availableTimes: sortAvailableTimes(item.horariosDisponiveis),
		recommendations: item.dsRecomendacoes,
	}));
	const sortedAvailableTimesByProviderName = sortByKey(parsedResponse, 'professionalName');

	return sortedAvailableTimesByProviderName;
}
